// v-clamp-tooltip.js
import { nextTick } from 'vue';

export default {
    mounted(el, binding) {
        let tooltipEl = null;

        const destroyTooltip = () => {
            if (tooltipEl && tooltipEl.remove) {
                tooltipEl.remove();
                tooltipEl = null;
            }
        };

        const createTooltip = () => {
            destroyTooltip(); // Remove existing tooltip if any

            if (isClamped(el)) {
                const content = binding.value || el.textContent.trim();

                tooltipEl = document.createElement('div');
                tooltipEl.className = 'custom-tooltip';
                tooltipEl.textContent = content;
                document.body.appendChild(tooltipEl);

                const rect = el.getBoundingClientRect();

                // Set max-width equal to the element's width (before measuring height)
                tooltipEl.style.maxWidth = `${rect.width}px`;

                // Allow the DOM to render and calculate correct dimensions
                requestAnimationFrame(() => {
                    const tooltipRect = tooltipEl.getBoundingClientRect();

                    let top = rect.top + window.scrollY - tooltipRect.height - 8;
                    let left = rect.left + window.scrollX + (rect.width - tooltipRect.width) / 2;

                    // Prevent overflow on left/right
                    const padding = 8;
                    const viewportWidth = window.innerWidth;

                    if (left < padding) {
                        left = padding;
                    } else if (left + tooltipRect.width > viewportWidth - padding) {
                        left = viewportWidth - tooltipRect.width - padding;
                    }

                    // If not enough space above, show below
                    if (top < window.scrollY) {
                        top = rect.bottom + window.scrollY + 8;
                    }

                    tooltipEl.style.top = `${top}px`;
                    tooltipEl.style.left = `${left}px`;
                });
            }
        };

        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        nextTick(() => {
            if (isTouchDevice) {
                el.addEventListener('touchstart', createTooltip);
                el.addEventListener('touchend', destroyTooltip);
                el.addEventListener('touchcancel', destroyTooltip);
            } else {
                el.addEventListener('mouseenter', createTooltip);
                el.addEventListener('mouseleave', destroyTooltip);
            }
        });
    },
    unmounted() {
        // Tooltip is auto-cleaned on leave/touch end
    }
};

// Utility: Check if element's content is visually truncated
function isClamped(el) {
    return el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
}
